/**
 * 神策埋点
 */
import { asyncLoadJs } from './util.client'
import { formatDate, getCountry } from './utils'
import { $http } from '@/api/request'
import domain from '../server-config/domain.config'
import { customEventFn, eventName as biEventName } from '@/plugins/bi-sa.client'

type platformType = 'Android APP' | 'IOS APP' |'PC' | 'WAP'

// 常见 爬虫头，不进行上报
const CRAWLER_USER_AGENTS = ['Googlebot', 'Bingbot', 'Slurp', 'DuckDuckBot', 'Baiduspider', 'YandexBot', 'Sogou', 'Exabot', 'facebot', 'ia_archiver'];

/** 是否为爬虫 */
const isCrawler = (): boolean => {
  const userAgent = navigator.userAgent

  const _has = CRAWLER_USER_AGENTS.some((item) => userAgent.includes(item))
  _has && console.info(`爬虫：`, userAgent)

  return _has
}

/** 是否为无头浏览器 */
const isHeadless = ():boolean => {
  const _has = navigator.webdriver || 
    /HeadlessChrome/.test(navigator.userAgent) || 
    // (navigator.plugins.length === 0) || 
    (window.outerWidth === 0 && window.outerHeight === 0)

  _has && console.info(`无头浏览器`)

  return  _has
}

interface IConfig {
  // 采集平台
  platformType: platformType
  /**
   * 用户信息采集配置
   * key:string -> 采集的属性名
   * value: string -> UserInfo 中对应的位置，profile.gender 表示 UserInfo['profile']['gender']
   */
  userAttr?: {
    email?: string
    userId?: string
    phoneNumber?: string
    googlePushId?: string // WAP 没有
    GAID?: string // WAP 没有
    $name?: string
    Gender?: string
    BirthYear?: string // 目前用户信息没有
    BirthMonth?: string // 目前用户信息没有
    Birthday ?: string // 目前用户信息没有
    Age?: string // 目前都是 0
  },
  // 排除的事件
  excludeEvent: string[]
  // 排除的事件属性
  excludeEventAttr: string[]
  // 排除的用户属性
  excludeUserAttr: string[],
  // 自定义事件通用属性
  customEventCommonAttr: {
    // platformType: platformType
    platform_type: platformType
    $app_id?: string
    $app_version?: string
    $brand?: string
    $model?: string
    $os?: string
    $os_version?: string
    $wifi?: string
    user_id?: string
    $carrier?: string
    $is_first_day?: boolean
    $is_login_id?: boolean
    $device_id?: string
    country: string
    [key: string]: any
  },
  /** 神策通用属性 */
  properties: IAnyObject
}
export const config: IConfig = {
  platformType: 'WAP',
  userAttr: {
    email: 'email',
    userId: 'userId',
    phoneNumber: 'phone',
    $name: 'nick',
    Gender: 'profile.gender',
    Age: 'profile.age'
  },
  excludeEvent: ['$WebStay', '$WebPageLeave', '$WebPageLoad', '$ABTestTrigger', '$ChannelLinkReaching'],
  excludeEventAttr: [
    '$lib', '$lib_version', '$lib_method', '$screen_height', '$screen_width',
    '$url_host', '$timezone_offset', '$latest_referrer_host', '$latest_utm_source',
    '$latest_utm_term', '$latest_utm_content', '$latest_utm_campaign', '$latest_utm_medium', '$latest_search_keyword',
    '$latest_traffic_source_type', '$viewport_width', '$viewport_height', '$page_height', '$manufacturer', '$bot_name'
  ],
  excludeUserAttr: [
    '$first_visit_time', '$utm_source', '$utm_medium', '$utm_term', '$utm_content',
    '$utm_campaign', '$first_referrer', '$first_referrer_host', '$first_browser_language',
    '$first_browser_charset', '$first_search_keyword', '$first_traffic_source_type'
  ],
  customEventCommonAttr: {
    platform_type: 'WAP',
    country: 'KE'
  },
  properties: {}
}

export enum SENSORS_EVENT {
  /**  ---- 前端埋点 ---- */
  registerSuccess = 'registerSuccess',
  LoginSuccess = 'loginSuccess',
  addAddressSuccess = 'addAddressSuccess',
  editAddressSuccess = 'editAddressSuccess',
  // 曝光埋点，目前只有广告位
  exposureProduct = 'exposureProduct',
  // 搜索埋点（与 BI searchEvent 同时触发，字段为驼峰）
  search = 'search',

  /** ---- 后端埋点 ---- */
  viewProductDetail = 'viewProductDetail',
  addToCart = 'addToCart',
  addToFavorites = 'addToFavorites',
  // 后端埋点 submitOrderSuccess 事件再前端没有用到
  // 只需要再 skuItems 里面将 sourceModel、sourceValue 和 sourceType 带过去就可以了
  submitOrderSuccess = 'submitOrderSuccess',
  payOrderSuccess = 'payOrderSuccess',

  /** ---- 用户行为 - 前端埋点---- */
  // 创建支付单事件（提单页点击 Place Order 按钮）
  clickPlaceOrder = 'clickPlaceOrder',
  // 商详页点击Buyer Now，提单页创建预下单事件
  clickOrderNow = 'clickOrderNow',
  // 购物车点击CheckOut事件，提单页创建预下单事件
  clickCheckOut = 'clickCheckOut',
  // 商详页浏览事件
  goodsDetailsScreen = 'goodsDetailsScreen',

  clickToShareButton = 'clickToShareButton',
  clickToShareChannel = 'clickToShareChannel'
}

export enum TRACK_SOURCE_MODULE {
  search = 'search',
  category = 'category',
  cart = 'cart',
  accountCenter = 'accountCenter',
  homePage = 'homePage',
  messageCenter = 'messageCenter',
  liveChat = 'liveChat',
  store = 'store',
  orderDetails = 'orderDetails',
  productDetails = 'productDetails'
}

export const setProfile = (sensors: any) => {
  if(!sensors) {
    return console.error('not init sensors!!!')
  }
  const userInfo = JSON.parse(JSON.stringify(useUserInfo().value) || '{}')

  if(config.userAttr && userInfo.userId) {
    const userAttr: IAnyObject = {}
    Object.keys(config.userAttr).forEach((k: string) => {
      const keys: string[] = (config.userAttr![k as keyof IConfig["userAttr"]] as string).split('.')

      let v: any = userInfo
      keys.forEach((k: string) => {
        v = v[k] || ''
      })

      v && (userAttr[k] = v)
    })
    sensors.login(userInfo.userId)
    sensors.setProfile(userAttr)
    getCustomEventCommonAttrs(sensors)
    return
  }

  // 登出：清除用户属性并重置登录 ID（神策 SDK 标准 API：login / logout 成对使用）
  if (config.userAttr) {
    sensors.unsetProfile(Object.keys(config.userAttr))
  }
  sensors.logout()
  getCustomEventCommonAttrs(sensors)
}

export const sensorsLogin = (sensors: any) => {
  const userInfo = JSON.parse(JSON.stringify(useUserInfo().value) || '{}')
  userInfo.userId && sensors.login(userInfo.userId)
}

const initTrackAllSensors = (sensors: any) => {
  config.platformType = useIsMobile().value ? 'WAP' : 'PC'
  config.customEventCommonAttr.platform_type = config.platformType

  // 爬虫
  if(isCrawler() || isHeadless()) {
    return
  }

  sensors.registerPropertyPlugin({
    isMatchedWithFilter: (data: IAnyObject) => {
      const route = useRoute()
      const isExclude = config.excludeEvent.includes(data.event)

      if(data.event === '$WebClick') {
        data.properties.$screen_name = route.name
      }
      if(data.event === '$pageview' || data.event === '$WebClick') {
        data.properties.country = getCountry()?.code || 'KE'
      }
      
      return !isExclude
    },
    properties: (data: IAnyObject) => {
      if(data.type !== 'profile_set') {
        data.properties.platform_type = config.platformType
      }

      config.excludeEventAttr.forEach((attr: string)=> {
        delete data.properties[attr]
      })
      config.excludeUserAttr.forEach((attr: string) => {
        delete data.properties[attr]
      })

      // config.properties = data.properties
    }
  })

  sensors.init({
    server_url: domain.SENSORS_URL,
    // 开启 DIV 埋点
    heatmap: { scroll_notice_map:'not_collect', collect_tags: { div : true }, img: true  },
    is_track_single_page: true,
    use_client_time: true,
    send_type: 'beacon',
    // debugger: true,
    app_js_bridge: true,
    // show_log: false // RUN_NODE_ENV !== 'PRODUCTION'
    show_log: false
  });
  
  sensors.quick('autoTrack');

  setProfile(sensors)
}

const getCustomEventCommonAttrs = (sensors: any) => {
  const sensorsCommonAttrs = sensors.getPresetProperties()
  const $is_login_id = !!useCookie('UserInfo').value
  const {
    $timezone_offset,
    $screen_height,
    $screen_width,
    $lib,
    $lib_version,
    $os_version,
    $os,
    $model,
    $is_first_day
  } = sensorsCommonAttrs

  Object.assign(
    config.customEventCommonAttr,
    { 
      $timezone_offset, $screen_height, $screen_width,
      $lib, $lib_version, $os_version, $os, $model,
      /** 以下为 APP 的属性，WAP / PC 没有 */
      gps_adid: '', adjust_id: '', $manufacturer: '', $brand: '',
      $app_version: '', $carrier: '', $app_id: '', $app_name: '',
      $device_id: '', $wifi: false, $network_type: ''
    }
  )

  config.customEventCommonAttr.$is_first_day = $is_first_day
  config.customEventCommonAttr.$is_login_id = $is_login_id
  config.customEventCommonAttr.country = getCountry()?.code || 'KE'
  config.customEventCommonAttr.user_id = useCookie<IUserInfo>('UserInfo').value?.userId || useCookie('anon_sid').value || String(new Date().getTime())
}

/**
 * 自定义采集事件
 * @param sensors sensors
 * @returns (key: string, data: IAnyObject) => void
 */
export const sensorsTrack = (sensors: any): (key: SENSORS_EVENT, data: IAnyObject) => void => {
  // 爬虫
  if(isCrawler() || isHeadless()) { return () => { } }
  
  return (key: SENSORS_EVENT, data: IAnyObject = {}) => {
    const _eventData = { ...config.customEventCommonAttr, ...data }

    // if(RUN_NODE_ENV !== 'PRODUCTION') {
      // console.info('sensorsTrack: ', key, _eventData)
    // }

    sensors.track(key, _eventData);
  }
}

export const registerSuccessTrack = (
  registerMethod: 'phone' | 'facebook' | 'email' | 'google' | 'whatsapp',
  registerSource: 'normal' | 'inviteCode' = 'normal'
) => {
  const sensors = getSensorsInstance()
  
  sensorsTrack(sensors)(SENSORS_EVENT.registerSuccess, { registerMethod, registerSource })
}

const addressSuccessTrack = (
  eventName: SENSORS_EVENT,
  recipientNumber: string | number,
  receiptMethod: 'DeliveryToDoorstep' | 'pickupStation',
  addressDetail: string,
  areaNameList: Address.IAreaName[],
  method?: string
) => {
  const sensors = getSensorsInstance()
  const _trackData: IAnyObject = { 
    recipientNumber,
    receiptMethod,
    addressDetail,
    method
  }

  // 地址目前只保留3级
  const _trackAreaNames = ['County', 'Subcounty', 'Area']

  areaNameList.forEach((item: Address.IAreaName, idx: number) => {
    _trackData[_trackAreaNames[idx]] = item.name
  })

  sensorsTrack(sensors)(eventName, _trackData)
}

export const addAddressSuccessTrack = (
  recipientNumber: string | number,
  receiptMethod: 'DeliveryToDoorstep' | 'pickupStation',
  addressDetail: string,
  areaNameList: Address.IAreaName[],
  method?: string
) => {
  addressSuccessTrack(SENSORS_EVENT.addAddressSuccess, recipientNumber, receiptMethod, addressDetail, areaNameList, method)
}

export const editAddressSuccessTrack = (
  recipientNumber: string | number,
  receiptMethod: 'DeliveryToDoorstep' | 'pickupStation',
  addressDetail: string,
  areaNameList: Address.IAreaName[],
  method?: string
) => {
  addressSuccessTrack(SENSORS_EVENT.editAddressSuccess, recipientNumber, receiptMethod, addressDetail, areaNameList, method)
}

const serverTrack = (
  eventName: SENSORS_EVENT,
  eventData: IAnyObject,
  customProperties?: IAnyObject,
  callback?: (res: any) => void
): void => {
  // 爬虫
  if(isCrawler() || isHeadless()) {
    return console.warn('sensorsTrack: crawler || headless')
  }
  // 没有 user_id 不进行上报，后端会报错
  if(!config.customEventCommonAttr.user_id) {
    return console.warn('sensorsTrack: user_id is empty')
  }

  const propertiesData = {
    isAd: !!customProperties?.isAd,
    isNewTag: !!customProperties?.isNewTag,
    isChoiceTag: !!customProperties?.isChoiceTag,
    requestId: customProperties?.requestId || ''
  }

  if(customProperties?.productInventoryType) {
    customProperties.productInventoryType = customProperties.productInventoryType
  }

  const trackBody = {
    eventName,
    eventData,
    properties: {
      ...config.customEventCommonAttr,
      ...propertiesData,
      $time: new Date().getTime()
    }
  }
  // 新BI埋点和神策埋点合并传递Event: 三个事件 （viewProductDetail | addToCart | addToFavorites）
  if (['viewProductDetail', 'addToFavorites', 'addToCart'].includes(eventName)) {
    const biEventData = {
      internal_latest_traffic_source_module: trackBody.eventData.internalLatestTrafficSourceModule,
      internal_latest_traffic_source_type: trackBody.eventData.internalLatestTrafficSourceType,
      inside_latest_traffic_source_value: trackBody.eventData.insideLatestTrafficSourceValue,
      internal_first_traffic_source_page: trackBody.eventData.internalFirstTrafficSourcePage,
      internal_latest_traffic_source_page: trackBody.eventData.internalLatestTrafficSourcePage,
      listing_id: trackBody.eventData.listingId,
      sku_id: trackBody.eventData.skuId,
      category_id: trackBody.eventData.categoryId,
      store_id: trackBody.eventData.storeId,
      isAd: trackBody.properties.isAd,
      is_new_tag: trackBody.properties.isNewTag,
      is_choice_tag: trackBody.properties.isChoiceTag,
      request_id: trackBody.properties.requestId || '',
      algorithm_model_name: trackBody.eventData.algorithmModelName || '',
      product_title: trackBody.eventData.productTitle,
      product_price: trackBody.eventData.productPrice,
      product_inventory_type: trackBody.eventData.productInventoryType ?
        trackBody.eventData.productInventoryType.toUpperCase() :
        trackBody.eventData.productInventoryType,
      sensor_properties: { ...trackBody.eventData, ...trackBody.properties },
    }

    const biProperties = {
      sensor_properties: trackBody.properties
    }
    if (eventName === 'viewProductDetail') {
      customEventFn(biEventName.viewProductDetail, biEventData, biProperties )
    } else if(eventName === 'addToFavorites') {
      customEventFn(biEventName.addToFavorites, biEventData, biProperties )
    } else {
      customEventFn(biEventName.addToCart, biEventData, biProperties )
    }
    
  } else {
    $http.post({
      url: `${domain.BASE_URL}/event`,
      body: trackBody,
      loading: false,
      server: false
    }).then((res: any) => {
      callback && callback(res)
    })
  }
}

export const getSensorsInstance = () => (window as any)['sensorsDataAnalytic201505']

type ExternalLastTrafficSource = {
  externalLastTrafficSourceType?: string,
  externalLastTrafficSourceChannel?: string,
  externalLastTrafficValue?: string,
}
const externalLastTrafficSource = () => {
  // 外部渠道来源归因 数据
  if(typeof window !== 'undefined' && window.localStorage) {
    const oldSourceAttr = localStorage.getItem('sensors_source_attribution')
    let sourceJson: { v: number, source: ExternalLastTrafficSource } = { v: 0, source: {} }
    
    if(oldSourceAttr) {
      sourceJson = JSON.parse(oldSourceAttr)

      // 默认保存七天
      if((new Date().getTime() - sourceJson.v) > 1000 * 60 * 60 * 24 * 7) {
        localStorage.removeItem('sensors_source_attribution')
        sourceJson = { v: 0, source: {} }
      }
    }

    const searchParams = new URLSearchParams(location.search)

    const externalLastTrafficSourceType = searchParams.get('externalLastTrafficSourceType') || 'organic'
    const externalLastTrafficSourceChannel = searchParams.get('externalLastTrafficSourceChannel') || (useIsMobile().value ? 'WAP' : 'PC')
    const externalLastTrafficValue = searchParams.get('externalLastTrafficValue') || ''

    if(externalLastTrafficSourceType || externalLastTrafficSourceChannel || externalLastTrafficValue) {
      sourceJson.source = {
        externalLastTrafficSourceType,
        externalLastTrafficSourceChannel,
        externalLastTrafficValue
      }
      sourceJson.v = new Date().getTime()
    }

    if(sourceJson.v !== 0) {
      localStorage.setItem('sensors_source_attribution', JSON.stringify(sourceJson))
    }
  }
}

const getExternalLastTrafficSource = (): ExternalLastTrafficSource => {
  const oldSourceAttr = localStorage.getItem('sensors_source_attribution')
  
  if(oldSourceAttr) {
    const sourceJson = JSON.parse(oldSourceAttr)

    return sourceJson.source
  }

  return {}
}

export default defineNuxtPlugin(async(NuxtApp) => {
  let sensors = null
  
  externalLastTrafficSource()
  
  if(!/\/pvHome/.test(useRoute().path) && !isCrawler() && !isHeadless()) {
    // 延迟加载非关键脚本，优化首屏性能
    const loadSensors = async () => {
      await asyncLoadJs('https://img.kilimall.com/c/h5/js/sensorsdata.min.js', { id: 'sensors-jssdk', ready: () => !!getSensorsInstance()?.init })
      
      sensors = getSensorsInstance()
      initTrackAllSensors(sensors)
      getCustomEventCommonAttrs(sensors)
      sensorsLogin(sensors)
    }
    
    await loadSensors().catch(() => console.warn('Unable to initialize analytics SDK'))
  }
  return {
    provide: {
      sensors,
      sensorsConfig: config,
      serverTrack,

      SENSORS_EVENT,
      TRACK_SOURCE_MODULE,
      
      sensorsTrack: sensorsTrack(sensors),

      setProfile,
      sensorsLogin,
      registerSuccessTrack,
      getExternalLastTrafficSource,
      addAddressSuccessTrack,
      editAddressSuccessTrack
    }
  }
})
